const $ = jQuery.noConflict();

'use strict';

const UpdatePassword = {
	$submitBtn: $('.js-reset-password-btn'),
	isFetching: false,

	init: function() {
		this.bindEvents();
	},

	bindEvents: function() {
		this.$submitBtn.on('click', this.submitNewPassword);
	},

	showMessage: function(message, type = 'error') {
		const $messageContainer = $('.js-reset-password-messages');
		const messageClass = type === 'success' ? 'profile-auth__success' : 'profile-auth__error';

		$messageContainer.html(`<div class="${messageClass}">${message}</div>`);
	},

	clearMessages: function() {
		$('.js-reset-password-messages').html('');
	},

	submitNewPassword: async function(event) {
		event.preventDefault();

		if (UpdatePassword.isFetching) {
			return;
		}

		const urlParams = new URLSearchParams(window.location.search);
		const token = urlParams.get('token');

		if (!token) {
			UpdatePassword.showMessage('Nevažeći token.');
			return;
		}

		const newPassword = $('#reset-field-new-password').val().trim();
		const confirmPassword = $('#reset-field-confirm-password').val().trim();

		UpdatePassword.clearMessages();

		if (!newPassword || newPassword.length < 8) {
			UpdatePassword.showMessage('Lozinka mora imati najmanje 8 karaktera.');
			return;
		}

		if (newPassword !== confirmPassword) {
			UpdatePassword.showMessage('Lozinke se ne podudaraju.');
			return;
		}

		UpdatePassword.isFetching = true;

		try {
			const response = await fetch('/wp-json/office-pulse-api/v1/auth/update-credentials', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({token, password: newPassword}),
			});

			const result = await response.json();

			if (response.ok && result.success) {
				UpdatePassword.showMessage('Lozinka je uspešno promenjena. Bićete preusmereni na stranicu za prijavu...', 'success');

				// redirect to login after 3 seconds
				setTimeout(() => {
					window.location.href = '/login';
				}, 3000);
			} else {
				UpdatePassword.showMessage(result.error || 'Došlo je do greške.');
			}
		} catch (error) {
			UpdatePassword.showMessage('Došlo je do greške. Pokušajte ponovo kasnije.');
		} finally {
			UpdatePassword.isFetching = false;
		}
	},
};

export default UpdatePassword;
